<template>
  <div class="wrapper">
    <el-row class="container">
      <el-col :span="8" :xs="24" class="container-left">
        <div style="margin-top: 15px; margin-bottom: 15px">
          <el-input
            placeholder="请输入物料名称123"
            v-model="listForm.productName"
            clearable
            class="input-with-select"
            maxlength="50"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchList()"
            ></el-button>
          </el-input>
        </div>
        <el-table
          :data="list"
          class="company-table"
          style="width: 100%"
          highlight-current-row
          ref="multipleTable"
          border
          @row-click="handleCurrentSelect"
          ><el-table-column
            type="index"
            label="序号"
            width="80"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="productName"
            label="物料名称"
          ></el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :current-page="listForm.pageNum"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </el-col>
      <el-col :span="16" :xs="24" class="container-right">
        <div class="scan-box">
          <div class="content-logo">
            <img src="../../../image/scan/banner.jpg" alt />
          </div>
          <div class="search-info">
            <p class="search-num">此产品查询次数1次</p>
            <p class="search-date">首次查询：2023-07-06 14:56:27</p>
            <p class="search-company">
              您所查询的产品是由深圳芭田生态工程股份有限公司生产的产品
            </p>
          </div>
          <div class="tracecode-box">88.493.8000/bt/800101085680592146585</div>
          <div class="content-details">
            <ul>
              <li>
                <p class="li-label">产品名称：</p>
                <p class="li-name">{{ productName }}</p>
              </li>
              <li>
                <p class="li-label">净含量：</p>
                <p class="li-name">{{ specifications }}</p>
              </li>
              <li>
                <p class="li-label">产品合格证：</p>
                <p class="li-name">
                  <span style="color: #2e35ff">点击查看</span>
                </p>
              </li>
              <li>
                <p class="li-label">生产企业：</p>
                <p class="li-name">见外包装</p>
              </li>
              <li>
                <p class="li-label">生产地址：</p>
                <p class="li-name">见外包装</p>
              </li>
              <li>
                <p class="li-label">网址：</p>
                <p class="li-name">见外包装</p>
              </li>
              <li>
                <p class="li-label">服务电话：</p>
                <p class="li-name">见外包装</p>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="scan-qrcode">
          <div id="qrcode" class="qr-code"></div>
          <span style="font-size: 14px">扫码预览效果</span>
        </div> -->
      </el-col>
    </el-row>
    <el-dialog
      title="更换模板"
      :visible.sync="dialogEdit"
      :close-on-click-modal="false"
      width="50%"
      @close="editClose"
    >
      <div class="company-name">选择模板</div>
      <ul class="img-box">
        <li
          v-for="(item, index) in imgList"
          :key="index"
          @click="selectImg(item, index)"
          :class="isActive == index ? 'active' : ''"
        >
          <img :src="item.imgUrl" />
          <span></span>
        </li>
      </ul>
      <div slot="footer">
        <el-button @click="dialogEdit = false">取 消</el-button>
        <el-button type="primary" @click="handleSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getProductPageList,
  productScanTemp,
  productScanTempList,
  updateTemp,
  refreshCode
} from "@/common/api.js";
import QRCode from "qrcodejs2";
export default {
  components: {},
  props: {},
  data() {
    return {
      list: [],
      loading: false,
      total: 0,
      listForm: {
        pageNum: 1,
        pageSize: 10,
        productName: "",
        productionProductTypeId: null,
        lockFlag: ""
      },
      tempUrl: "",
      dialogEdit: false,
      imgList: [],
      isActive: null,
      productId: "",
      tempId: "",
      value1: true,
      value2: true,
      value3: true,
      updateTata: {},
      standardCode: "",
      productName: "",
      specifications:"",
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 产品列表
    getPageList() {
      var params = this.listForm;
      this.loading = true;
      getProductPageList(params).then(res => {
        this.loading = false;
        if (res.errorCode == 200) {
          this.list = res.pageInfo.list;
          this.total = res.pageInfo.total;
          this.$nextTick(() => {
            this.$refs.multipleTable.setCurrentRow(this.list[0]);
            this.handleCurrentSelect(this.list[0]);
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 刷新码信息
    refreshCode() {
      var data = {
        standardCode: this.standardCode
      };
      refreshCode(data).then(res => {
        if (res.errorCode == 200) {
          this.$message({
            type: "success",
            message: "刷新成功"
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 模板列表
    getProductScanTempList() {
      productScanTempList().then(res => {
        if (res.errorCode == 200) {
          this.imgList = res.data;
        } else {
          console.log(res.msg);
          // this.$message.error(res.msg);
        }
      });
    },
    //生成二维码
    qrcode(code) {
      document.getElementById("qrcode").innerHTML = "";
      let qrcode = new QRCode("qrcode", {
        width: 120,
        height: 120,
        colorDark: "#000000"
      });
      qrcode.clear();
      qrcode.makeCode(code);
    },
    //企业查询
    searchList() {
      this.listForm.pageNum = 1;
      this.getPageList();
    },
    //选中
    handleCurrentSelect(row) {
      console.log(row);
      this.$refs.multipleTable.toggleRowSelection(row, true); //点击选中
      this.productId = row.productId;
      this.productName = row.productName;
      this.specifications=row.specifications;
      var data = {
        productId: row.productId
      };
      productScanTemp(data).then(res => {
        console.log(res)
        if (res.errorCode == 200) {
          this.standardCode = res.standardCode;
          this.qrcode("https://km.batian.com.cn/" + res.standardCode);
          this.tempUrl = res.imgUrl;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 关闭新增/编辑弹框
    editClose() {
      this.isActive = null;
      this.tempId = "";
    },
    handleCurrentChange(cpage) {
      this.listForm.pageNum = cpage;
      this.getPageList();
    },
    handleSizeChange(psize) {
      this.listForm.pageSize = psize;
      this.getPageList();
    },
    selectImg(item, index) {
      this.isActive = index;
      this.tempId = item.id;
      // this.updateTata = item;
      // this.updateTata.productId = this.productId;
    },
    handleSave() {
      if (this.tempId) {
        var data = {
          productId: this.productId,
          tempId: this.tempId
        };
        updateTemp(data).then(res => {
          if (res.errorCode == 200) {
            this.$message({
              type: "success",
              message: "保存成功"
            });
            this.dialogEdit = false;
            this.isActive = null;
            this.tempId = "";
            var data = {
              productId: this.productId
            };
            productScanTemp(data).then(res => {
              if (res.errorCode == 200) {
                this.tempUrl = res.imgUrl;
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.$message.error("请选择模板");
      }
    },
    //重置
    reset() {
      this.addOrEditForm = {
        ruleId: "",
        companyId: "",
        isDefault: null,
        id: ""
      };
      this.id = "";
    }
  },
  created() {},
  mounted() {
    this.getPageList();
    this.getProductScanTempList();
  }
};
</script>
<style lang="less" scoped>
.wrapper {
  width: auto;
  height: 100%;
  margin-left: -20px;
  .el-row {
    height: 100%;
  }
  .add-config {
    margin-left: 15px;
    margin-top: 3px;
  }
  .el-tag {
    margin-left: 10px;
  }

  .company-name {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
    margin-left: 20px;
  }
  .container {
    display: flex;
    .container-left {
      padding: 0 10px;
      background-color: #fff;
      height: 100%;
      .container-title {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #eee;
        .el-icon-arrow-down {
          margin-left: 15px;
          font-weight: 800;
        }
        .expand-btn {
          img {
            width: 15px;
            height: 15px;
            vertical-align: middle;
            margin-left: 5px;
            transform: rotate(0deg);
            transition: transform 0.5s;
          }
          .active {
            transform: rotate(180deg);
            transition: transform 0.5s;
          }
        }
      }
      /deep/.el-table td {
        padding: 10px 0;
      }
      /deep/.el-table__body tr.current-row > td {
        background-color: #949494;
        color: #ffffff;
      }
      .el-pagination {
        overflow: auto;
        padding: 10px 5px;
      }
    }
    .container-right {
      border-radius: 6px;
      margin-top: 10px;
      margin-left: 12px;
      display: flex;
      .add-button {
        margin: 10px 0;
      }
      .table-box {
        padding: 5px 10px 12px;
        background-color: #ffffff;
        border-radius: 6px;
        margin-top: 10px;
        height: 100%;
        .view-box {
          height: 100%;
          .img-view {
            height: 600px;
            width: auto;
          }
        }
      }
      .scan-box {
        width: 375px;
        height: 800px;
        box-shadow: 0 0 5px 0 #6d6d6d;
        .content-logo {
          width: 100%;
          img {
            width: 100%;
            height: auto;
          }
          .company-name {
            font-size: 14px;
            text-align: center;
            width: 80%;
            margin: 0 auto;
            color: #b0823b;
          }
        }
        .search-info {
          padding: 20px 5%;
          width: 90%;
          margin: 0 auto;
          background-color: #fff;
          font-size: 14px;
          .search-date {
            color: #e92d23;
            padding: 10px 0;
          }
          .search-company {
            line-height: 1.5;
          }
        }
        .tracecode-box {
          padding: 20px 5%;
          font-size: 14px;
          background-color: #fff;
          margin: 10px 0;
        }
        .content-details {
          background-color: #fff;
          padding: 20px 0;
          ul {
            width: 90%;
            margin: 0 auto;
            li {
              display: flex;
              width: 100%;
              margin-top: 20px;
              .li-label {
                // width: 80px;
                font-size: 14px;
                color: #60605f;
                flex-shrink: 0;
              }
              .li-name {
                width: calc(100% - 100px);
                font-size: 14px;
                color: #343434;
                word-break: break-word;
              }
            }
          }
        }
      }
      .scan-qrcode{
        margin-left: 30px;
      }
    }
  }
  .corrent-dialog {
    .list-title {
      font-size: 18px;
      font-weight: 500;
    }
    .record-tips {
      margin: 15px 0;
    }
    /deep/.el-table__body tr.current-row > td {
      background-color: #02813b;
      color: #ffffff;
    }
  }
  .isCode /deep/.el-form-item__label {
    line-height: 20px;
  }
  .form-title {
    height: 40px;
    // line-height: 40px;
    font-size: 15px;
    // color: #666666;
  }
  .btn-checkbox {
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #13ce66;
      border-color: #13ce66;
    }
    /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
      color: #13ce66;
    }
  }
  /deep/.el-input__inner,
  /deep/.el-form-item__content {
    height: 34px;
    line-height: 34px;
  }
  /deep/.el-input__icon,
  /deep/.el-form-item__label {
    line-height: 34px;
  }

  .tracecode-rules /deep/.el-table__header-wrapper {
    th:first-child {
      .cell {
        // width: 60px;
        .el-checkbox {
          display: none;
        }
      }
      .cell:after {
        content: "请选择";
      }
    }
  }
  .img-box {
    display: flex;
    flex-wrap: wrap;
    // justify-content :space-between;
    li {
      width: 20%;
      margin: 0 2.5%;
      img {
        width: 100%;
        height: auto;
      }
      border: 2px dashed #949494;
      position: relative;
    }
    li.active {
      border: 2px dashed #f6462f;
    }
    li.active span {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 30px;
      height: 30px;
      background-image: url("../../../image/icon/select1.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      // content: "";
      // f6462f  bfbfbf
    }
  }
  .qr-code {
    text-align: center;
    /deep/img {
      display: inline-block !important;
      margin-bottom: 10px;
    }
  }
  .refresh {
    color: #3398fd;
    margin-left: 10px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/system/scanManage/scanTemplete.vue